export interface CubeConfigDto {
    token: string
}